<template>
    <vs-table noDataText="No data" :data="data">
            <template slot="thead">
        <vs-th>Archivos</vs-th>
        <vs-th>Fecha creación</vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td style="display: flex; flex-direction: row;">
            <a style="padding-left: 10px;" :href="tr.file" target="_blank">
              Ver
            </a>  
          </vs-td>
          <vs-td>
            {{ dateFormatter(tr.created_at) }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

</template>

<script>
import { dateFormatter } from '../../../../utils/strings';

export default {
    name: 'agency-odc-table',
    props: {
        data: {
            type: Array,
            required: true
        },
    },
    data() {
        return {
            dateFormatter
        }
    }
}
</script>
